import { render, staticRenderFns } from "./institutionHome.vue?vue&type=template&id=2495e580&scoped=true&"
import script from "./institutionHome.vue?vue&type=script&lang=js&"
export * from "./institutionHome.vue?vue&type=script&lang=js&"
import style0 from "./institutionHome.vue?vue&type=style&index=0&id=2495e580&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495e580",
  null
  
)

export default component.exports